import { getDefaultCompBrand } from "../constants";
import { setBrandsInScreen } from "./commandCenter/screens/screen";
import { setGraphBrands } from "./dashboard/Welcome";
import { setTemplateDetails } from "./section/section";

export const setSelectLogicalBrandValue = (value) => {
  return { type: "SET_LOGICAL_BRAND_VALUE", payload: value };
};

export const setLogicalBrandCheckedItems = (value) => {
  return { type: "SET_LOGICAL_BRAND_CHECKED_ITEMS", payload: value };
};

const defaultBrandState = (brands, defaultValue, Allbrands, singleBrands) => {
  let check = brands?.length === singleBrands?.length ? { All: true } : {};
  let myArr = [];
  if (defaultValue) {
    if (brands[0]?.brand_group_name) {
      myArr?.push({
        group: true,
        type: "include",
        brand_group_name: brands[0]?.brand_group_name,
        brand_group_list: brands?.[0]?.brand_list,
        brand_friendly_name: brands[0]?.brand_group_name,
        name: brands[0]?.brand_group_name,
        brand_image: brands[0]?.brand_logo_image,
        brand_name: brands[0]?.brand_name,
        category_group_id: brands[0]?.category_group_id,
      });
      check = { ...check, [brands[0]?.brand_group_name + "_group"]: true };
    } else {
      myArr.push({
        group: false,
        type: "include",
        brand_group_name: brands[0]?.brand_group_name,
        brand_group_list: brands?.[0]?.brand_list,
        brand_friendly_name: brands[0]?.brand_friendly_name,
        name: brands[0]?.brand_id,
        brand_image: brands[0]?.brand_image
          ? brands[0]?.brand_image
          : brands[0]?.brand_logo
          ? brands[0]?.brand_logo
          : null,
        category_group_id: brands[0]?.category_group_id,
      });
      check = { ...check, [brands[0]?.brand_friendly_name]: true };
    }
  } else {
    Array.isArray(brands) &&
      brands?.map((el, i) => {
        if (el?.group || el?.brand_group_name) {
          myArr.push({
            group: true,
            type: "include",
            brand_group_name: el?.brand_group_name,
            brand_group_list: el?.brand_group_list,
            brand_friendly_name: el?.brand_group_name,
            name: el?.brand_group_name,
            brand_image: el?.brand_logo_image
              ? el?.brand_logo_image
              : el?.brand_image
              ? el?.brand_image
              : el?.brand_logo,
            category_group_id: el?.category_group_id,
          });
          return (check = {
            ...check,
            [el?.brand_group_name + "_group"]: true,
          });
        } else {
          myArr.push({
            group: false,
            type: "include",
            brand_group_name: el?.brand_group_name,
            brand_group_list: el?.brand_group_list,
            brand_friendly_name: el?.brand_friendly_name,
            name: el?.name ? el?.name : el?.brand_id,
            brand_name: el?.brand_name,
            brand_image: el?.brand_image ? el?.brand_image : el?.brand_logo,
            category_group_id: el?.category_group_id,
          });
          return (check = { ...check, [el?.brand_friendly_name]: true });
        }
      });
  }

  return {
    check: check,
    myArr: myArr,
  };
};

export const setGlobalLogicalBrandValue = (brandsObject) => {
  let updateselectValue = { ...brandsObject?.selectLogicalBrandValue };
  let updatecheckedValue = { ...brandsObject?.logicalBrandCheckedItems };

  if (brandsObject?.value) {
    let obj = {};
    if (
      (brandsObject?.value[0]?.columns &&
        brandsObject?.value[0].columns[0]?.competitor) ||
      brandsObject?.value[0]?.competitor
    ) {
      let value = brandsObject?.value[0]?.columns
        ? brandsObject?.value[0]?.columns
        : brandsObject?.value;
      obj.myArr = value;
      let check = { [value[0]?.brand_name + "_parent"]: true };
      value[0]?.competitorList?.map((el) => {
        check = {
          ...check,
          [el?.brand_name + value[0]?.brand_name]: true,
        };
      });
      obj.check = check;
    } else if (
      brandsObject?.template_type === "competition" &&
      !brandsObject?.value
    ) {
      let a = getDefaultCompBrand(brandsObject?.competitorBrandsValue);
      obj.myArr = a;
      let check = { [a[0]?.brand_name + "_parent"]: true };
      a[0]?.competitorList?.map((el) => {
        check = {
          ...check,
          [el?.brand_name + a[0]?.brand_name]: true,
        };
      });
      obj.check = check;
    } else {
      obj = defaultBrandState(
        brandsObject?.value[0]?.columns
          ? brandsObject?.value[0]?.columns
          : brandsObject?.value,
        false,
        brandsObject?.brands,
        brandsObject?.singleBrands
      );
    }

    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  } else if (!brandsObject?.value) {
    let obj = {};

    if (
      brandsObject?.template_type === "competition" &&
      brandsObject?.competitorBrandsValue
    ) {
      let comp_arr =
        brandsObject?.competitorBrandsValue[0]?.comp_brand_list?.filter(
          (el, i) => {
            if (i < 5) return el;
          }
        );

      let a = [
        {
          group: false,
          name: brandsObject?.competitorBrandsValue[0]?.brand_id,
          type: "include",
          brand_name: brandsObject?.competitorBrandsValue[0]?.brand_name,
          brand_friendly_name:
            brandsObject?.competitorBrandsValue[0]?.brand_friendly_name,
          brand_color: brandsObject?.competitorBrandsValue[0]?.brand_color,
          brand_group_name: null,
          competitor: true,
          competitorList: comp_arr?.map((el, i) => {
            return {
              brand_id: el?.comp_brand_id,
              brand_name: el?.comp_brand_name,
              brand_friendly_name: el?.comp_brand_friendly_name,
              comp_brand_color: el?.comp_brand_color,
            };
          }),
        },
      ];
      obj.myArr = a;
      let check = { [a[0]?.brand_name + "_parent"]: true };
      a[0]?.competitorList?.map((el) => {
        check = {
          ...check,
          [el?.brand_name + a[0]?.brand_name]: true,
        };
      });
      obj.check = check;
    } else {
      obj = defaultBrandState(brandsObject?.brands, true);
    }

    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  }

  return (dispatch) => {
    dispatch({ type: "SET_LOGICAL_BRAND_VALUE", payload: updateselectValue });
    dispatch({
      type: "SET_LOGICAL_BRAND_CHECKED_ITEMS",
      payload: updatecheckedValue,
    });
  };
};

export const setSectionLogicalBrandValue = (brandsObject) => {
  let updateselectValue = { ...brandsObject?.selectLogicalBrandValue };
  let updatecheckedValue = { ...brandsObject?.logicalBrandCheckedItems };

  if (brandsObject?.value) {
    let obj = defaultBrandState(
      brandsObject?.value[0]?.columns,
      false,
      brandsObject?.brands,
      brandsObject?.singleBrands
    );
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  } else {
    let obj = defaultBrandState(brandsObject?.brands, true);
    updatecheckedValue[brandsObject?.type].data = {};
    updateselectValue[brandsObject?.type].data = {
      columns: [],
      attribute: "BrandID",
      type: "varchar",
    };
  }

  return (dispatch) => {
    dispatch({ type: "SET_LOGICAL_BRAND_VALUE", payload: updateselectValue });
    dispatch({
      type: "SET_LOGICAL_BRAND_CHECKED_ITEMS",
      payload: updatecheckedValue,
    });
  };
};

export const setWidgetLogicalBrandValue = (brandsObject) => {
  let updateselectValue = { ...brandsObject?.selectLogicalBrandValue };
  let updatecheckedValue = { ...brandsObject?.logicalBrandCheckedItems };

  if (brandsObject?.value) {
    let obj = defaultBrandState(
      brandsObject?.value[0]?.columns,
      false,
      brandsObject?.brands,
      brandsObject?.singleBrands
    );
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  } else {
    let obj = defaultBrandState(brandsObject?.brands, true);
    updatecheckedValue[brandsObject?.type].data = {};
    updateselectValue[brandsObject?.type].data = {
      columns: [],
      attribute: "BrandID",
      type: "varchar",
    };
  }

  return (dispatch) => {
    dispatch({ type: "SET_LOGICAL_BRAND_VALUE", payload: updateselectValue });
    dispatch({
      type: "SET_LOGICAL_BRAND_CHECKED_ITEMS",
      payload: updatecheckedValue,
    });
  };
};
export const setGraphPageLogicalBrandValue = (brandsObject) => {
  let updateselectValue = { ...brandsObject?.selectLogicalBrandValue };
  let updatecheckedValue = { ...brandsObject?.logicalBrandCheckedItems };

  if (brandsObject?.value) {
    let obj = {};
    if (brandsObject?.value[0]?.competitor) {
      obj.myArr = brandsObject?.value;
      let check = { [brandsObject?.value[0]?.brand_name + "_parent"]: true };
      brandsObject?.value[0]?.competitorList?.map((el) => {
        check = {
          ...check,
          [el?.brand_name + brandsObject?.value[0]?.brand_name]: true,
        };
      });
      obj.check = check;
    } else {
      obj = defaultBrandState(
        brandsObject?.value,
        false,
        brandsObject?.brands,
        brandsObject?.singleBrands,
        brandsObject?.singleBrands
      );
    }
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  } else {
    let obj = defaultBrandState(brandsObject?.brands, true);
    updatecheckedValue[brandsObject?.type].data = obj?.check;
    updateselectValue[brandsObject?.type].data = {
      columns: obj?.myArr,
      attribute: "BrandID",
      type: "varchar",
    };
  }

  return (dispatch) => {
    dispatch({ type: "SET_LOGICAL_BRAND_VALUE", payload: updateselectValue });
    dispatch({
      type: "SET_LOGICAL_BRAND_CHECKED_ITEMS",
      payload: updatecheckedValue,
    });
  };
};
export const setPreviewBrands = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_PREVIEW_BRANDS", payload: value });
  };
};
